import React from "react";
import { Link } from "react-router-dom";

function money(n) {
  const v = Number(n);
  if (Number.isNaN(v)) return null;
  return `$${v.toFixed(2)}`;
}

export default function RequestCard({
  request,
  categories = [],
  compact = false,
  actionTo = "/categories",
  actionLabel = "Offer an item →",
}) {
  if (!request || request.id == null) return null;

  const title = request.title || "Request";
  const status = String(request.status || "open");

  const budget = request?.max_budget ?? request?.budget ?? 0;
  const budgetText = money(budget);
  const preferred = request.preferred_condition
    ? String(request.preferred_condition)
    : "";

  const catId =
    request.product_category_id != null
      ? String(request.product_category_id)
      : "";
  const cat = categories.find((c) => String(c.id) === catId);
  const catLabel = cat?.title || cat?.label || "";

  const chips = [catLabel, preferred].filter(Boolean).slice(0, 2);

  const area = request.area ? String(request.area) : "";
  const when = request.when ? String(request.when) : "";
  const metaBits = [area, when].filter(Boolean);
  const meta = metaBits.join(" • ");

  return (
    <div className={`rCard2 ${compact ? "rCard2Compact" : ""}`}>
      <div className="rTop">
        <span className={`rPill rPill-${status}`}>{status}</span>

        {budgetText ? (
          <span className="rBudget2">Up to {budgetText}</span>
        ) : (
          <span className="rBudget2 muted">Budget: -</span>
        )}
      </div>

      <div className="rTitle2" title={title}>
        {title}
      </div>

      {chips.length ? (
        <div className="rChips">
          {chips.map((t) => (
            <span key={t} className="rChip">
              {t}
            </span>
          ))}
        </div>
      ) : null}

      {meta ? <div className="rMeta2">{meta}</div> : null}

      <div className="rBottom">
        <Link className="rCta2" to={`/requests/${request.id}`}>
          {"View →"}
        </Link>
      </div>
    </div>
  );
}
